import { hasValue } from '@repo/utils';

const EMPTY_DISPLAY = '—';

export function formatTableNumber(value: unknown, decimalPlaces: number, locale: string): string {
  if (!hasValue(value) || typeof value !== 'number' || Number.isNaN(value)) {
    return EMPTY_DISPLAY;
  }

  return value.toLocaleString(locale, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
    useGrouping: false,
  });
}
